const FORMULA_TRIGGERS = ['=', '+', '-', '@', '\t', '\r']

/** BOM UTF-8: faz o Excel reconhecer acentos ao abrir o CSV. */
const UTF8_BOM = '﻿'

/**
 * Escapa um campo para CSV (RFC 4180) e neutraliza injeção de fórmula em planilhas: uma célula iniciada por
 * `= + - @` (ou tab/CR) é interpretada como comando pelo Excel/Sheets, então prefixamos com apóstrofo.
 */
export function csvField(value: string): string {
  let text = value

  if (text.length > 0 && FORMULA_TRIGGERS.includes(text.charAt(0))) {
    text = `'${text}`
  }

  if (/["\n\r,]/.test(text)) {
    text = `"${text.replaceAll('"', '""')}"`
  }

  return text
}

/**
 * Monta um documento CSV (com BOM UTF-8) a partir de cabeçalhos e linhas. Cada célula é escapada por
 * {@link csvField}. Linhas terminam em CRLF.
 */
export function buildCsv(headers: readonly string[], rows: readonly (readonly string[])[]): string {
  const lines = [headers.map(csvField).join(','), ...rows.map((row) => row.map(csvField).join(','))]

  return `${UTF8_BOM}${lines.join('\r\n')}\r\n`
}
